import React from 'react';
import { MainLayoutHeader, MainLayoutHeaderProps } from '@app/components';

export const CustomerHeader = ({ children }: Pick<MainLayoutHeaderProps, 'children'>) => {
  return (
    <MainLayoutHeader
      tabs={[
        { label: 'Clients', screenName: 'CustomerScreen', permissions: ['dashboard::customers.read'] },
        // { label: 'Export', screenName: 'CustomerExportScreen', permissions: ['dashboard::customers.export-csv'] },
      ]}
    >
      {children}
    </MainLayoutHeader>
  );
};
